export default `
    fields {
        name
        value
    }
`;
